import axios from "axios";
import { BASE_URL } from "../constants/APIConstants";
import { authConfig, deleteResource, getResource } from "../api/http";

// Audio tracks and subtitles attached to a media (`contentURL` is the media type segment).

export function getAudioTracks(contentURL, media_id) {
  return getResource(`/api/audio/${contentURL}/${media_id}`, { fallback: [] });
}

export function deleteAudioTrack(contentURL, media_id, audioTrack_id) {
  return deleteResource(
    `/api/audio/${contentURL}/${media_id}/${audioTrack_id}`
  );
}

export function getSubtitles(contentURL, media_id) {
  return getResource(`/api/subtitles/${contentURL}/${media_id}`, {
    fallback: [],
  });
}

export function deleteSubtitle(contentURL, media_id, subtitle_id) {
  return deleteResource(
    `/api/subtitles/${contentURL}/${media_id}/${subtitle_id}`
  );
}

// Creation calls resolve with the raw axios response, consumed as is by the
// redux actions.

export function addAudioTrack(contentURL, media_id, track) {
  return axios.post(
    `${BASE_URL}/api/audio/${contentURL}/${media_id}`,
    track,
    authConfig()
  );
}

export function addSubtitle(contentURL, media_id, subtitle) {
  return axios.post(
    `${BASE_URL}/api/subtitles/${contentURL}/${media_id}`,
    subtitle,
    authConfig()
  );
}
